<script setup lang="ts">
import { useRoute } from 'vue-router'
import { Home, Images, UserRound } from 'lucide-vue-next'

const route = useRoute()
const homeRoutes = new Set(['home', 'veiculo', 'checklist', 'nova-os'])
</script>

<template>
  <nav aria-label="Navegação principal">
    <router-link to="/" :class="{ active: homeRoutes.has(String(route.name)) }"><Home :size="20"/>Hoje</router-link>
    <router-link to="/fotos" :class="{ active: route.name === 'fotos' }"><Images :size="20"/>Fotos</router-link>
    <router-link to="/perfil" :class="{ active: route.name === 'perfil' || route.name === 'relatorios' || route.name === 'historico' }"><UserRound :size="20"/>Perfil</router-link>
  </nav>
</template>

<style scoped>
nav{position:fixed;left:50%;bottom:0;transform:translateX(-50%);width:min(620px,100%);display:grid;grid-template-columns:repeat(3,1fr);padding:10px 8px calc(8px + env(safe-area-inset-bottom));border-top:1px solid var(--ck-cream-300);background:color-mix(in srgb,var(--ck-cream-50) 92%,transparent);backdrop-filter:blur(14px)}
nav a{display:flex;flex-direction:column;align-items:center;gap:3px;color:var(--ck-text-muted);font-size:10px;text-decoration:none}
nav svg{width:20px}
.active{color:var(--ck-orange-500)}
</style>
